import {
  IAccountExperienceParams,
  IAccountExperienceRegister,
  IAccountExperienceResetPassword
} from '@aqx-core/common/api/account-experience';
import { request } from '@aqx-core/common/request';

export default {
  resetPassword: (params: IAccountExperienceParams) =>
    request.patch<IAccountExperienceResetPassword>('/api/auth/v1/experience/password/reset', undefined, { params }),
  register: (params: IAccountExperienceParams) =>
    request.post<IAccountExperienceRegister>('/api/account/experience/v1/register', params)
};
